"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventCard = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _Card = _interopRequireDefault(require("@material-ui/core/Card"));
var _CardHeader = _interopRequireDefault(require("@material-ui/core/CardHeader"));
var _CardMedia = _interopRequireDefault(require("@material-ui/core/CardMedia"));
var _Typography = require("./Typography");
var _pittaModules = require("@thingsw/pitta-modules");
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _IconButton = require("./IconButton");
var _FileType = _interopRequireDefault(require("./FileType"));
var _styles2 = require("@material-ui/styles");
var _lodash = _interopRequireDefault(require("lodash"));
var _ThumbnailBroken = require("../icons/ThumbnailBroken");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles.createStyles)({
    root1: {
      // maxWidth: 300,
      padding: "9px 16px 16px",
      boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.05), 0px 3px 15px rgba(0, 0, 0, 0.1), 0px 0px 8px rgba(0, 0, 0, 0.08)",
      borderRadius: 4,
      border: "1px solid ".concat(_pittaModules.LightColors.primary["5"])
    },
    root: {
      padding: 0
    },
    action: {
      marginTop: 5,
      marginRight: -6
    },
    close: {
      color: _pittaModules.LightColors.primary["1"],
      padding: 3
    },
    media: {
      position: "relative",
      margin: "8px 0",
      display: "flex",
      justifyContent: "center"
    },
    event: _objectSpread({
      position: "absolute",
      zIndex: 2,
      // padding: 4,
      width: 46
    }, theme.direction === "rtl" ? {
      left: 3.2,
      top: 3.5
    } : {
      right: 3.2,
      top: 3.5
    }),
    back: _objectSpread(_objectSpread({
      backgroundColor: _pittaModules.LightColors.primary["1"],
      width: 54,
      height: 28,
      opacity: 0.45,
      position: "absolute",
      zIndex: 1
    }, theme.direction === "rtl" ? {
      left: 0
    } : {
      right: 0
    }), theme.direction === "rtl" ? {
      borderRadius: "0 0 10px 0"
    } : {
      borderRadius: "0 0 0 10px"
    }),
    footer: {
      display: "flex",
      flexDirection: "column"
    },
    mode: {
      paddingBottom: 2,
      color: _pittaModules.LightColors.primary["1"]
    },
    date: {
      color: _pittaModules.LightColors.primary["2"]
    },
    img: {
      width: 268,
      height: 151,
      fill: "none"
    }
  });
});
var regex = new RegExp(/(\[[\u0000-\uFFFF]+\])?([\u0000-\uFFFF]+)/);
var EventCard = function EventCard(props) {
  var classes = useStyles();
  var theme = (0, _styles2.useTheme)();
  var event = props.event,
    fileType = props.fileType,
    model = props.model,
    onClose = props.onClose,
    t = props.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    imgError = _useState2[0],
    setImgError = _useState2[1];
  var getThumbnail = (0, _react.useCallback)(function () {
    if (imgError) {
      return /*#__PURE__*/_react.default.createElement(_ThumbnailBroken.ThumbnailBroken, {
        className: classes.img
      });
    } else if (_lodash.default.includes(_pittaModules.THUMBNAIL_EVENTS, event.msg_code)) {
      return /*#__PURE__*/_react.default.createElement("img", {
        alt: "thumbnail",
        className: classes.img,
        src: event.image_url,
        onError: function onError() {
          return setImgError(true);
        }
      });
    }
  }, [classes.img, event.image_url, event.msg_code, imgError]);
  var _useMemo = (0, _react.useMemo)(function () {
      var matches = event.alert.match(regex);
      if (matches) {
        return [matches[1], matches[2]];
      } else {
        return [undefined, undefined];
      }
    }, [event.alert]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    devName = _useMemo2[0],
    message = _useMemo2[1];
  var vdate = (0, _react.useMemo)(function () {
    if (event.event_filename) {
      var dateStrings = event.event_filename.split("_");
      return (0, _moment.default)("".concat(dateStrings[0], " ").concat(dateStrings[1]), "YYYYMMDD HHmmss");
    }
    return undefined;
  }, [event.event_filename]);
  return /*#__PURE__*/_react.default.createElement(_Card.default, {
    className: classes.root1,
    dir: theme.direction
  }, /*#__PURE__*/_react.default.createElement(_CardHeader.default
  // className={classes.header}
  , {
    classes: classes,
    action: /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
      className: classes.close,
      onClick: onClose
    }, /*#__PURE__*/_react.default.createElement(_Close.default, null)),
    title: /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
      variant: "BodyBold",
      category: "Default"
    }, devName),
    subheader: /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
      variant: "Small",
      category: "Default"
    }, model)
  }), /*#__PURE__*/_react.default.createElement(_CardMedia.default, {
    className: classes.media
  }, getThumbnail(), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.back
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.event
  }, /*#__PURE__*/_react.default.createElement(_FileType.default, {
    fileType: fileType,
    t: t
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Small",
    className: classes.mode
  }, message), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Small",
    className: classes.date
  }, vdate === null || vdate === void 0 ? void 0 : vdate.format("MMM DD, h:m:ss A"))));
};
exports.EventCard = EventCard;